import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Popper from "@mui/material/Popper";
import HailIcon from "@mui/icons-material/Hail";
import { useTheme } from "@mui/material/styles";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import TaxiAlertIcon from "@mui/icons-material/TaxiAlert";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function CallCardSmall({
  element,
  index,
  remakeCall,
  setshowModal,
  setcancelObject,
}) {
  // 1) Data
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isOpened, setisOpened] = useState(false);

  // 3) Functions
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setisOpened(!isOpened);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setisOpened(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  return (
    <>
      {/* Small Icon Cards */}
      <div
        //style={customStylesBackground()}
        className="mx-2 px-2 mb-2   h-12 cursor-pointer w-12 flex items-center justify-center "
        onClick={handleClick}
      >
        <div className="GlassEffectSmallIcons rounded-md shadow-md shadow-gray-300">
          <IconButton
            color="third"
            aria-label="upload picture"
            component="label"
            aria-describedby={index}
          >
            {!isOpened ? (
              <>
                {(element.info.callStatus === 30 ||
                  element.info.callStatus === 31) && (
                  <div className="flex flex-col justify-center items-center w-8">
                    <DoDisturbOnIcon fontSize="" className="text-white" />
                    <p className="text-xs">{element.drvid}</p>
                  </div>
                )}
                {(element.info.callStatus === 0 ||
                  element.info.callStatus === 1) && (
                  <>
                    <div className="flex flex-col justify-center items-center w-8 h-9">
                      <PersonSearchIcon
                        fontSize="large"
                        className="text-gray-100"
                      />
                    </div>
                  </>
                )}
                {(element.info.callStatus === 20 ||
                  element.info.callStatus === 21) && (
                  <>
                    <div className="flex flex-col justify-center items-center w-8 h-9">
                      <TaxiAlertIcon
                        fontSize="large"
                        className="text-gray-100"
                      />
                    </div>
                  </>
                )}
                {(element.info.callStatus === 10 ||
                  element.info.callStatus === 11) && (
                  <div className="flex flex-col justify-center items-center w-8 h-9">
                    <HailIcon fontSize="large" className="text-gray-100" />
                    <p className="text-xs">{element.drvid}</p>
                  </div>
                )}
              </>
            ) : (
              <>
                {element.status === "Cancelled" && (
                  <CloseIcon className="text-white" />
                )}
                {element.status !== "Cancelled" && <CloseIcon />}
              </>
            )}
          </IconButton>
          <Typography variant="body2" color="white">
            {element.info.taxiNo}
          </Typography>
        </div>
      </div>
      {/* Popper Container */}
      <Popper
        className="GlassEffectSmallBoxes"
        id={index}
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        style={{ marginBottom: 10 }}
      >
        {(element.info.callStatus === 30 || element.info.callStatus === 31) && (
          <Box className=" text-center mb-2">
            <div className="flex justify-center items-center text-red-800 pt-2 ">
              <DoDisturbOnIcon
                style={{
                  marginRight: 5,
                }}
              />
              <h3 className="text-lg font-semibold ">Ακυρώθηκε</h3>
            </div>
            <div className=" p-2 rounded-md mb-1 pt-3 pb-3 ">
              <div className="text-red-800">
                <div className="px-3 pt-1 mb-0.5">
                  <div className="">{t("Όνομ/μο_Οδηγού")}</div>
                  <div className="font-semibold">
                    {element.driverFirstName + " " + element.driverLastName}
                  </div>
                </div>

                <div className="px-3 pt-1 mb-0.5">
                  <div className="">{t("Όνομ/μο Πελάτη")}</div>
                  <div className="font-semibold">
                    {element.info.customerName}
                  </div>
                </div>
              </div>
            </div>
          </Box>
        )}
        {(element.info.callStatus === 0 || element.info.callStatus === 1) && (
          <Box className="rounded-lg  text-center mb-2 px-2 pt-1">
            <h3 className="text-lg font-semibold text-indigo-800 mt-2">
              {t("Searching")}
            </h3>
            <div className="flex justify-center mt-2">
              <img
                src={require("../../Images/Universal/hourglass.gif")}
                width={50}
              />{" "}
            </div>

            <div className="p-2 rounded-md mb-1 mt-1 text-indigo-800">
              <p>
                {t("Destination") + " : "}
                <br />
                <span className="font-semibold">
                  {element.info.destination}
                </span>
              </p>
            </div>
          </Box>
        )}
        {(element.info.callStatus === 20 || element.info.callStatus === 21) && (
          <Box className="text-center ">
            <h3 className="text-lg font-semibold text-gray-600 pt-1 px-2 mt-1">
              {t("Δεν_βρέθηκε_όχημα")}
            </h3>

            <div className="p-2 rounded-md mb-1 ">
              <p className="text-gray-600">
                {t("Destination") + " : "}
                <br />
                <span className="font-semibold">
                  {" "}
                  {element.info.destination}
                </span>
              </p>
              <TaxiAlertIcon
                className="text-gray-600"
                style={{
                  width: 50,
                  height: 50,
                }}
              />

              <div className="px-2 py-1 mt-2 ">
                <Button
                  variant="contained"
                  onClick={() => remakeCall(element.info)}
                >
                  {t("Επανάληψη_κλήσης")}
                </Button>
              </div>
            </div>
          </Box>
        )}
        {(element.info.callStatus === 10 || element.info.callStatus === 11) && (
          <Box className="rounded-lg text-center  pt-1">
            <div className="flex justify-center items-center">
              <LocalTaxiIcon
                className="text-green-700"
                style={{
                  marginRight: 5,
                }}
              />
              <h3 className="text-lg font-semibold text-green-700 mt-1">
                {t("Το_όχημα_έχει_βρεθεί")}
              </h3>
            </div>
            <div className=" p-2 rounded-md mb-1  text-green-800">
              <div>
                <div className="px-3 mb-0.5">
                  <div className="">{t("Destination")}</div>
                  <div className="font-semibold">
                    {element.info.destination}
                    {element.distance == undefined && "  "}
                    {element.distance != undefined && " - " + element.distance}
                    {element.duration == undefined && "  "}
                    {element.duration != undefined && " - " + element.duration}
                  </div>
                </div>
                <div className="px-3 pt-1 mb-0.5">
                  <div className="">{t("Στοιχεία_ΤΑΞΙ")}</div>
                  <div className="font-semibold">
                    {t("Πινακίδα") + " " + element.taxiLicNo}
                  </div>
                </div>

                <div className="px-3 pt-1 mb-0.5">
                  <div className="">{t("Όνομ/μο_Οδηγού")}</div>
                  <div className="font-semibold">
                    {element.driverFirstName + " " + element.driverLastName}
                  </div>
                </div>

                <div className="px-3 pt-1 mb-0.5">
                  <div className="">{t("Όνομ/μο Πελάτη")}</div>
                  <div className="font-semibold">
                    {element.info.customerName}
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <Button
                onClick={async () => {
                  await setcancelObject(element);
                  console.log("Cancel Objext : ", element.info);
                  setshowModal(true);
                }}
                variant="contained"
              >
                {t("Ακύρωση_Κλήσης")}
              </Button>
            </div>
          </Box>
        )}
      </Popper>
    </>
  );
}

export default CallCardSmall;
